<template>
  <div class="vectors">
    <h2>Wektor</h2>

    <div class="load">
      <input ref="upload" type="file" @change="insertFile" />
    </div>

    <template v-if="currentObject">
      <el-row :gutter="10">
        <p style="font-size: 14px; margin-bottom: 5px;">Kolor</p>
        <el-col :span="4">
          <el-color-picker :value="getFill" @change="setFill"></el-color-picker>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <p style="font-size: 14px; margin-bottom: 5px;">Obramowanie</p>
        <el-col :span="4">
          <el-color-picker :value="currentObject.stroke" @change="setStroke" show-alpha size="mini"></el-color-picker>
        </el-col>
        
        <el-col :span="20">
          <el-input-number @change="setStrokeWidth" :min="0" v-model="currentObject.strokeWidth" size="mini"></el-input-number>
        </el-col>
      </el-row>

      <el-button v-if="currentObject.type === 'group'" class="ungroup" type="success" @click="unGroup">
        Rozgrupuj
      </el-button>
    </template>
  </div>
</template>

<script>
import Editor from "../../classes/Editor";

export default {
  data() {
    return {
      currentObject: null,
    }
  },
  computed: {
    getFill() {
      return this.currentObject.fill
    },
  },
  async mounted() {
    Editor.addCallback('selection:created', () => {
      this.currentObject = Editor.canvas.getActiveObject()
      console.log('type ==========', this.currentObject.type)
    })
    
    Editor.addCallback('selection:updated', () => {
      this.currentObject = Editor.canvas.getActiveObject()
    })   

    Editor.addCallback('selection:cleared', () => {
      this.currentObject = null
    })
  },
  methods: {
    setFill(color) {
      this.printInfromation();
      Editor.setStyleForActiveObject('fill', color, false, false);
    },
    setStroke(color) {
      this.printInfromation();
      Editor.setStyleForActiveObject('stroke', color, false, false);
    },
    setStrokeWidth(stroke) {
      Editor.setStyleForActiveObject('strokeWidth', stroke, false, false);
    },
    printInfromation() {
      const showPrintInfromation = !localStorage.printInfromation;
      if (showPrintInfromation) {
        this.$alert('Zmieniając kolor należy mieć na uwadze, że ostateczny kolor może się nieznacznie różnić od wybranego, ponieważ zależy to od rodzaju i ustawień monitora.', 'Uwaga!', {
          confirmButtonText: 'OK',
          type: 'warning',
        });

        localStorage.printInfromation = true;
      }
    },
    insertFile(data) {
      console.log("insert file", data);

      const file = this.$refs.upload.files[0];
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          // convert image file to base64 string
          // preview.src = reader.result;
          console.log("reader", reader);
          Editor.addSvg(reader.result, "svg");
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    unGroup() {
      const group = Editor.canvas.getActiveObject();
      var items = group.getObjects();
      group.destroy();
      console.log("items", items);

      items.forEach((item) => Editor.canvas.add(item));

      Editor.canvas.remove(group);
    },
  },
};
</script>

<style lang="less" scoped>

  .load {
    background: #f7f7f7;
    padding: 10px;
    box-sizing: border-box;
  }

  .ungroup {
    margin-top: 20px;
  }
</style>